import { ChangeDetectionStrategy, Component, contentChildren, linkedSignal } from '@angular/core';
import { TabUIComponent } from './tab/tab.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'fr8bot-ui-tabs',
  imports: [NgTemplateOutlet],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsUIComponent {
  protected readonly tabs = contentChildren(TabUIComponent);

  // Opens the first tab; after that the user's choice stays.
  public readonly activeTabId = linkedSignal<readonly TabUIComponent[], string | null>({
    source: this.tabs,
    computation: (tabs, previous) => previous?.value ?? tabs[0]?.tabId() ?? null,
  });

  public onTabClick(activeTabId: string): void {
    this.activeTabId.set(activeTabId);
  }
}
